// @flow
import ContextEvent from 'app/common/lib/ContextEvent';
import ContextLogger from 'app/common/lib/ContextLogger';
import getClientTrackingParams from 'app/packages/client-tracking-params';
import store from 'app/common/redux/store/singleton';
import urlUtil from 'app/common/lib/urlUtil';
import { createTimeSpentManager } from 'app/packages/time-spent';

// tracking params hash map for caching
const timedPairsBegin = {};

const shouldShowLogStatements =
  urlUtil.getQueryStringParams() && urlUtil.getQueryStringParams().debug_timespent;

const track = (eventData: Object) => {
  const logger = ContextLogger.getInstance();
  const state = store.instance.getState();
  let clientTrackingParams;

  if (state.pins && eventData) {
    const { pair_id: pairId, event_type: eventType } = eventData;

    if (eventType === PCONST.thrift.EventType.TIMED_PAIR_END && timedPairsBegin[pairId]) {
      eventData.clientTrackingParams = timedPairsBegin[pairId];
    } else {
      const objectId = eventData.object_id_str;
      const pin = state.pins[objectId];
      const location = state.location;

      if (pin) {
        clientTrackingParams = getClientTrackingParams(pin, location) || `${pin.tracking_params}~0`;
        eventData.clientTrackingParams = clientTrackingParams;

        if (eventType === PCONST.thrift.EventType.TIMED_PAIR_BEGIN) {
          timedPairsBegin[pairId] = clientTrackingParams;
        }
      }
    }
  }

  const event = ContextEvent.fromPlainObject(eventData);

  logger.addEvent(event);
};

const flushEvents = (sync?: boolean) => {
  ContextLogger.getInstance().flushEvents(sync);
};

export default createTimeSpentManager({
  flushEvents,
  shouldShowLogStatements,
  track,
});
